import type { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import type { MButtonProps } from '../../molecules/MButton/MButton.types';
import type { MButtonIconProps } from '../../molecules/MButtonIcon/MButtonIcon.types';

export enum OMessageSitewideVariant {
  Dismissable = 'Dismissable',
}

export interface OMessageSitewideBaseProps {
  drawerState?: OMessageSitewideVariant;
  cta?: boolean | string;
  subheader?: boolean | string;
  aSubheader?: ASubheaderProps;
  mButton?: MButtonProps;
  mButtonIcon?: MButtonIconProps;
}

export interface OMessageSitewideProps extends OMessageSitewideBaseProps {
  onDismiss?: () => void;
  className?: string;
}


